export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.minhaescala_app'
export const IOS_STORE_URL = 'https://apps.apple.com/br/app/minha-escala/id6471288730'
export const ANDROID_DEEP_LINK = 'market://details?id=com.minhaescala_app'
export const IOS_DEEP_LINK = 'itms-apps://apps.apple.com/br/app/minha-escala/id6471288730'

export function isMobileUserAgent(userAgent: string = navigator.userAgent): boolean {
  return /android|iphone|ipad|ipod/i.test(userAgent)
}

export function openAppStore(onDesktopFallback?: () => void): void {
  const userAgent = navigator.userAgent

  if (/android/i.test(userAgent)) {
    window.location.href = ANDROID_DEEP_LINK
  } else if (/iphone|ipad|ipod/i.test(userAgent)) {
    window.location.href = IOS_DEEP_LINK
  } else {
    onDesktopFallback?.()
  }
}
